import { useQuery } from "@apollo/client";
import { Combobox } from "@/components/Combobox";
import { type ComboboxOption } from "@/components/Combobox/types";
import { graphql, type ResultOf } from "@/graphql";
import { useActiveBusinessUnit } from "@/hooks/use-active-business-unit";
import { removeNothings } from "@/lib/utils/arrays";

type ContactId = string; // e.g. "5"

type Props = {
  id?: string;
  selected: Array<ContactId>;
  onSelect: (values: Array<ContactId>) => void;
  className?: string;
};

export type LotSourcesData = ResultOf<typeof lotSourcesQuery>;

export function SourcePicker({ id, selected, onSelect, className }: Props) {
  const { activeBusinessUnitId } = useActiveBusinessUnit();
  const { data, loading } = useQuery(lotSourcesQuery, { variables: { businessUnitId: activeBusinessUnitId } });

  const options: Array<ComboboxOption> = getSourcesOptions(data);

  return (
    <Combobox
      id={id}
      name="sources"
      options={options}
      selected={selected}
      onChange={onSelect}
      loading={loading}
      type="multi"
      className={className}
    />
  );
}

export const getSourcesOptions = (data: LotSourcesData | undefined) => {
  const options = removeNothings(data?.supplyChainLotSourcePartners?.edges || []).map((source) => {
    return {
      label: source.node.businessName,
      value: source.node.id,
    };
  });

  return options;
};

export const lotSourcesQuery = graphql(`
  query SupplyChainLotSources($businessUnitId: ID) {
    supplyChainLotSourcePartners(businessUnit: $businessUnitId) {
      edges {
        node {
          id
          businessName
        }
      }
    }
  }
`);
